export default "__VITE_ASSET__aOSbKIe5__"